import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class CampaignService {
  constructor(private commonApiService: CommonApiService) {}

  onCreateCampaign(payload: any) {
    return this.commonApiService.post(APIURL.createNewCampaign, payload);
  }

  getCampaignsList(payload: any) {
    return this.commonApiService.get(APIURL.CampaignList, payload);
  }

  getCampaignsDetails(campaignId: number) {
    const url = `${APIURL.campaignDetails}/${campaignId}`;
    return this.commonApiService.get(url);
  }

  getCampaignTeamList(payload: any) {
    const params = this.commonApiService.getParamsFromObj(payload);
    return this.commonApiService.get(APIURL.campaignTeamList, params);
  }

  // onVideoProjectCreate(payload: any) {
  //   return this.commonApiService.post(APIURL.videoProjectCreate, payload);
  // }

  onCreateVideoConceptManifest(payload: any) {
    return this.commonApiService.post(
      APIURL.createVideoConceptManifest,
      payload,
    );
  }

  getCampaignHubStats() {
    return this.commonApiService.get(APIURL.camapaignHubStats);
  }
}
